import { useMemo } from 'react'
import { Trans } from 'react-i18next'
import { formatStratumSize } from '../utils'

const StratumDataItemValue = ({
  percentile,
  stratumSize,
}: {
  percentile?: number
  stratumSize: number
}) => {
  const formattedStratumSize = useMemo(() => formatStratumSize(stratumSize), [stratumSize])

  const props: {
    i18nKey: string
    defaults: string
    values: {
      percentile: string
      stratumSize: string
    }
  } = percentile
    ? {
        i18nKey: 'topPercentile',
        defaults: 'Top {{percentile}}%',
        values: {
          percentile: percentile.toString(),
          stratumSize: formattedStratumSize,
        },
      }
    : {
        i18nKey: 'topPercentileNoValue',
        defaults: 'N/A',
        values: {
          percentile: '',
          stratumSize: formattedStratumSize,
        },
      }

  return <Trans {...props} ns='strPlayerLevel' />
}

export default StratumDataItemValue
